import React from 'react';
import classnames from 'classnames';
import { useHistory, useLocation } from 'react-router-dom';
import { stringify as querify, parse as parseQuery } from 'qs';

const Pagination = ({ links, smallScreen }) => {
	const history = useHistory();
	const location = useLocation();

	const handleChangePage = (page: number) => {
		const query = parseQuery(location.search, { ignoreQueryPrefix: true });
		const searchString = querify(
			{ ...query, page },
			{
				addQueryPrefix: true,
			}
		);

		history.push({
			...location,
			search: searchString,
		});
	};

	if (!links || links.length === 3) {
		return null;
	}

	// <!-- dont render, if there's only 1 page (previous, 1, next) -->
	//   <!-- DESKTOP: all available links -->
	return !smallScreen ? (
		<div className="_justify-center _mt-6 _mb-1 _flex">
			{links.map(({ active, label, page }) => {
				if (page === null) {
					//   <!-- Previous, if on first page -->
					//   <!-- Next, if on last page -->
					return (
						<div
							key={label}
							className="_px-4 _py-3 _mb-1 _mr-1 _text-sm _text-gray-500 _border _border-gray-500 _rounded"
						>
							{label}
						</div>
					);
				}

				return (
					<button
						key={label}
						className={classnames(
							'_px-4 _py-3 _mb-1 _mr-1 _text-sm _border _rounded hover:_bg-white hover:_text-gray-700 focus:_border-gray-700 focus:_text-gray-700',
							{ '_bg-white': active, '_text-gray-700': active }
						)}
						onClick={() => handleChangePage(page)}
					>
						{label}
					</button>
				);
			})}
		</div>
	) : (
		// <!-- MOBILE: PREV <ACTIVE> NEXT Only -->
		<div className="_flex _justify-center _mt-6 _mb-1">
			{links.map(({ active, label, page }) => {
				if ((label === '<<' || label === '>>' || label === '<' || label === '>') && !page) {
					//   <!-- Previous, if on first page -->
					//   <!-- Next, if on last page -->
					return (
						<div
							key={label}
							className={classnames(
								'_px-4 _py-3 _mb-1 _mr-1 _text-sm _text-gray-600 _border _border-gray-600 _rounded',
								{ '_bg-white': active, '_text-gray-700': active }
							)}
						>
							{label}
						</div>
					);
				}

				if (active || ((label === '<<' || label === '>>' || label === '<' || label === '>') && page)) {
					return (
						<button
							key={label}
							className={classnames(
								'_px-4 _py-3 _mb-1 _mr-1 _text-sm _border _rounded hover:_bg-white hover:_text-gray-700 focus:_border-gray-700 focus:_text-gray-700',
								{ '_bg-white': active, '_text-gray-700': active }
							)}
							onClick={() => handleChangePage(page)}
						>
							{label}
						</button>
					);
				}

				return null;
			})}
		</div>
	);
};

export default Pagination;
